export const SMS_MONITOR_STATUSES = [
    { value: '', labelKey: 'all' },
    { value: 'queued', labelKey: 'queued' },
    { value: 'sending', labelKey: 'sending' },
    { value: 'sent', labelKey: 'sent' },
    { value: 'delivered', labelKey: 'delivered' },
    { value: 'undelivered', labelKey: 'undelivered' },
    { value: 'failed', labelKey: 'failed' },
    { value: 'accepted', labelKey: 'accepted' },
    { value: 'scheduled', labelKey: 'scheduled' },
    { value: 'canceled', labelKey: 'canceled' },
];

export const SMS_MONITOR_PAGE_SIZES = [10, 20, 50, 100];

export const SMS_MONITOR_DEFAULT_DAYS = 30;

export const getDefaultSmsMonitorDateRange = () => {
    const to = new Date();
    const from = new Date();
    from.setDate(from.getDate() - SMS_MONITOR_DEFAULT_DAYS);
    const toIso = (d) => d.toISOString().slice(0, 10);
    return { date_from: toIso(from), date_to: toIso(to) };
};

export const formatSmsMonitorDate = (iso) => {
    if (!iso) return '—';
    try {
        return new Date(iso).toLocaleString('fr-FR', {
            timeZone: 'Europe/Paris',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    } catch {
        return iso;
    }
};

export const truncateSmsSid = (sid) => {
    if (!sid || sid.length < 12) return sid || '—';
    return `${sid.slice(0, 8)}…${sid.slice(-4)}`;
};

export const truncateSmsBody = (body, max = 60) => {
    const text = body || '';
    if (text.length <= max) return text || '—';
    return `${text.slice(0, max)}…`;
};

export const getSmsStatusBadgeVariant = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'delivered') return 'success';
    if (s === 'sent') return 'primary';
    if (s === 'failed') return 'danger';
    if (s === 'undelivered') return 'warning';
    if (s === 'queued' || s === 'sending') return 'secondary';
    return 'secondary';
};

export const formatSmsCost = (price, priceUnit) => {
    if (price == null || price === '') return '—';
    const unit = priceUnit || '';
    return `${price} ${unit}`.trim();
};

export const SMS_MONITOR_EXPORT_MAX_PAGES = 100;

export const buildSmsMonitorExcelRows = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        SID: item.sid || '',
        'Date envoi': formatSmsMonitorDate(item.date_sent || item.date_created),
        Destinataire: item.to || '',
        Expéditeur: item.from_number || '',
        Message: item.body || '',
        Statut: item.status || '',
        Direction: item.direction || '',
        Coût: formatSmsCost(item.price, item.price_unit),
        'Date création': formatSmsMonitorDate(item.date_created),
        'Date mise à jour': formatSmsMonitorDate(item.date_updated),
        Segments: item.num_segments ?? '',
        Médias: item.num_media ?? '',
        'Code erreur': item.error_code ?? '',
        'Message erreur': item.error_message ?? '',
    }));
};

export const fetchAllSmsMonitorItems = async (appliedQuery, fetchPage) => {
    const allItems = [];
    let page = 1;
    const pageSize = 100;

    while (page <= SMS_MONITOR_EXPORT_MAX_PAGES) {
        const data = await fetchPage({
            page,
            page_size: pageSize,
            status: appliedQuery.status || undefined,
            date_from: appliedQuery.dateFrom || undefined,
            date_to: appliedQuery.dateTo || undefined,
            to_number: appliedQuery.toNumber || undefined,
            from_number: appliedQuery.fromNumber || undefined,
        });
        const batch = Array.isArray(data?.items) ? data.items : [];
        allItems.push(...batch);
        if (batch.length < pageSize) break;
        page += 1;
    }

    return allItems;
};
